import React from 'react';

const AnswerThree = () => {
  return (
    <div>
      <p className='text-16 text-grey font-dmsans_r leading-[24px]'>
        The maximum amount you can keep in your digital wallet on Pouchers depends on your wallet
        limit, which is determined by your account type and KYC verification level.,
      </p>
      <p className='text-16 text-grey font-dmsans_r leading-[24px] mt-3'>
        To increase your wallet limit, you may need to provide additional information or
        documentation as required by our compliance policies. Please refer to our website or contact
        our support team for more information on wallet limits and verification.
      </p>
    </div>
  );
};

export default AnswerThree;
